(() => {
  if (customElements.get('tints-addons')) return;
  const normalize = value => String(value || '').replace(/-/g, '').trim().toLowerCase();
  const write = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
  customElements.define('tints-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = this.closest('form');
      if (!this.form) return;
      this.ready = true;
      this.mainVariants = JSON.parse(this.querySelector('[data-main-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-addon-strings]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:this.dataset.currency || 'USD' });
      this.cards = [...this.querySelectorAll('[data-addon-card]')].map(element => ({
        element,
        variants:JSON.parse(element.querySelector('[data-addon-variants]').textContent),
        toggle:element.querySelector('[data-addon-toggle]'),
        options:[...element.querySelectorAll('[data-addon-option]')],
        kind:element.dataset.kind,
        discount:Number(element.dataset.discount || 0),
        discountTarget:element.dataset.discountTarget
      }));
      this.cards.forEach(card => card.options.forEach(select => {
        const name = select.dataset.optionName.toLowerCase();
        const preferred = name.includes('sticker') ? 'no' : name.includes('allen') ? 'yes' : '';
        if (preferred) select.value = [...select.options].find(o=>normalize(o.value)===preferred)?.value || '';
      }));
      this.onChange = () => this.update();
      this.container = this.closest('.product__info-container') || this.form;
      this.container.addEventListener('change', this.onChange);
      this.container.addEventListener('input', this.onChange);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(this.container,{attributes:true,attributeFilter:['value'],childList:true,subtree:true});
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.container?.removeEventListener('change',this.onChange);
      this.container?.removeEventListener('input',this.onChange);
      this.ready = false;
    }
    main() { return this.mainVariants.find(v=>String(v.id)===this.form.querySelector('[name="id"]')?.value); }
    variant(card) {
      const main = this.main();
      if (!main) return null;
      const options = [...(card.variants[0]?.options || [])];
      for (const select of card.options) options[Number(select.dataset.addonOption)] = select.value;
      if (card.kind === 'pack') {
        options[0] = main.options[0];
        options[2] = main.options[1];
      }
      if (options.some(v=>!v)) return null;
      return card.variants.find(v=>v.options.every((value,index)=>normalize(value)===normalize(options[index]))) || null;
    }
    selection() {
      const result = {items:[],replacement:null,mainDiscount:0,error:null};
      for (const card of this.cards || []) {
        if (!card.toggle?.checked) continue;
        const variant = this.variant(card);
        if (!variant) { result.error=this.strings.choose_error; break; }
        if (!variant.available) { result.error=this.strings.unavailable_error; break; }
        if (card.kind === 'pack') result.replacement=variant;
        else {
          result.items.push({id:variant.id,quantity:1,properties:{_44_tints_pairing:this.dataset.routingVersion}});
          if (card.discountTarget==='main') result.mainDiscount=Math.max(result.mainDiscount,card.discount);
        }
      }
      return result;
    }
    total(basePrice, quantity) {
      const result=this.selection();
      let total=(result.replacement?.price ?? basePrice)*quantity;
      total-=Math.floor(basePrice*result.mainDiscount/100);
      for (const card of this.cards || []) {
        if (!card.toggle?.checked || card.kind==='pack') continue;
        const variant=this.variant(card);
        if (variant?.available) total+=variant.price-(card.discountTarget==='addon'?Math.floor(variant.price*card.discount/100):0);
      }
      return total;
    }
    update() {
      const main=this.main();
      if (!main) return;
      for (const card of this.cards) {
        const options=card.element.querySelector('[data-addon-options]');
        if (options) options.hidden=!card.toggle?.checked;
        const variant=this.variant(card);
        const fallback=card.variants.filter(v=>v.available).sort((a,b)=>a.price-b.price)[0];
        const selected=variant || fallback;
        if (!selected) continue;
        let text='';
        if (card.kind==='pack') {
          const sticker=main.options[1];
          const pack=variant || card.variants.find(v=>v.available&&normalize(v.options[0])===normalize(main.options[0])&&normalize(v.options[2])===normalize(sticker)) || fallback;
          const extra=pack.price-main.price;
          const secondSingle=this.mainVariants.find(v=>normalize(v.options[0])===normalize(pack.options[1])&&normalize(v.options[1])==='no');
          const saving=main.price+(secondSingle?.price || main.price)-pack.price;
          text=`+ ${this.money.format(extra/100)} · ${this.strings.pack_price.replace('__PRICE__',this.money.format(pack.price/100))}`;
          const badge=card.element.querySelector('[data-pack-saving]');
          if(badge){badge.hidden=saving<=0;write(badge,this.strings.save_amount.replace('__AMOUNT__',this.money.format(saving/100)));}
        } else {
          const price=selected.price-(card.discountTarget==='addon'?Math.floor(selected.price*card.discount/100):0);
          text=`+ ${this.money.format(price/100)}`;
        }
        write(card.element.querySelector('[data-addon-price]'),text);
        const incomplete=card.toggle?.checked && !variant;
        write(card.element.querySelector('[data-addon-error]'),card.toggle?.checked && variant && !variant.available?this.strings.unavailable_error:'');
        card.options.forEach(select=>{select.required=Boolean(card.toggle?.checked);select.setAttribute('aria-invalid',String(Boolean(incomplete&&!select.value)));});
      }
      this.dispatchEvent(new CustomEvent('addons:change',{bubbles:true}));
    }
  });
})();
